import { API, Helpers, Router } from '../Helpers';
import Cleave from "cleave.js/react";
import { InputHidden } from '../Core';
import React, { Component, useState } from 'react';
import BookingWidget from '../BookingWidget/BookingWidget';
import ReactDOM from 'react-dom';
import { Notification, ReviewRating } from '../Shared';
import $ from 'jquery-validation';
import _, { takeWhile } from 'lodash';
import CartExpireCountdown from '../CartExpireCountdown';
import CartItem from '../CartItem';

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            billingCCExpMonth: "",
            billingCCExpYear: "",
            cart: this.props.data.cart,
            sidebar_recommendation: _.sample(this.props.data.related_tours.data),
            transaction: this.props.data.transaction,
            user_ip_address: this.props.data.env.APP_ENV == "local" ? this.props.data.env.APP_IP_ADDRESS : this.props.data.request_ip,
            currency: this.props.data.env.APP_CURRENCY || "USD",
            item_to_edit: null,
            target_tour_of_edit: null,
            is_editing_item: false,
            is_loading: false,
            show_loader: false,
            pickup_options_edit: [],
            editMessages: [],
            product_items_edit: [],
            bookingDefaultValues: {
                pickupLocation: null,
                pickupDate: null,
            },
            isCartExpired: false,
            failedPreserveItems: [],
            count: 0,
            localCart: null,
            cancellation_policy: null,
            terms_conditions: null
        };

        this.preserveCartItems = this.preserveCartItems.bind(this);
        this.removeFailedPreservedItem = this.removeFailedPreservedItem.bind(this);
        this.loadTourInfo = this.loadTourInfo.bind(this);
        this.applyCoupon = this.applyCoupon.bind(this);
        this.calculateDiscount = this.calculateDiscount.bind(this);
        this.calculateTaxesAndFees = this.calculateTaxesAndFees.bind(this);
        this.calculateTaxes = this.calculateTaxes.bind(this);
        this.calculateFees = this.calculateFees.bind(this);
        this.generateProductUrl = this.generateProductUrl.bind(this);
        this.createTransaction = this.createTransaction.bind(this);
        this.measureRemoveFromCart = this.measureRemoveFromCart.bind(this);
        this.onApplyCoupon = this.onApplyCoupon.bind(this);
        this.onBillingCCExpMonthChange = this.onBillingCCExpMonthChange.bind(this);
        this.onBillingCCExpYearChange = this.onBillingCCExpYearChange.bind(this);
        this.onCreditCardChange = this.onCreditCardChange.bind(this);
        this.onCreditCardTypeChanged = this.onCreditCardTypeChanged.bind(this);
        this.onCVVChange = this.onCVVChange.bind(this);
        this.onPhoneChange = this.onPhoneChange.bind(this);
        this.onRemoveFromCart = this.onRemoveFromCart.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.removeFromCart = this.removeFromCart.bind(this);
        this.loadCartItemInfo = this.loadCartItemInfo.bind(this);
        this.asyncRemoveItemFromCart = this.asyncRemoveItemFromCart.bind(this);
        this.addItemsToCart = this.addItemsToCart.bind(this);
        this.measureAddToCart = this.measureAddToCart.bind(this);
        this.UnpreservedItemsList = this.UnpreservedItemsList.bind(this);
        this.isBahamasSite = this.isBahamasSite.bind(this);
        this.isExclusiveSite = this.isExclusiveSite.bind(this);
    }

    componentDidMount() {
        $('#checkoutForm').validate({
            //debug: true,
            errorClass: "is-invalid",
            validClass: "is-valid",
            errorPlacement: (error, element) => { /*just nothing, empty*/ }
        });

        $('#couponForm').validate({
            //debug: true,
            errorClass: "is-invalid",
            validClass: "is-valid",
            errorPlacement: (error, element) => { /*just nothing, empty*/ }
        });

        //load cancellations and terms policy
        const settings = this.props.data.active_site.settings.data;
        const terms_conditions = settings.find(setting => setting.key == 'terms_conditions');
        const cancellation_policy = settings.find(setting => setting.key == 'cancellation_policy');
        this.setState({
            terms_conditions,
            cancellation_policy
        });

        //check if cart has all items in local storage
        const localCart = this.getLocalCart();

        if (localCart == null)
            return;

        const unpreservedItems = localCart.items.filter(({ item }) => {
            return !this.state.cart.items.find(cartItem => (
                cartItem.name === item.name
            ))
        });

        console.log("unpreserved items", unpreservedItems);
        this.setState({
            failedPreserveItems: unpreservedItems,
            localCart: localCart
        });
    }

    getLocalCart() {
        try {
            if (localStorage.getItem("cart") !== null) {
                const localCart = JSON.parse(localStorage.getItem("cart"));
                const now = new Date()
                if (localCart.expiration < now.getTime()) {
                    localStorage.removeItem("cart");
                    return null;
                } else {
                    return localCart;
                }
            }
            return null;

        } catch (e) {
            localStorage.removeItem("cart");
            return null;
        }
    }

    applyCoupon(event) {
        event.preventDefault();

        //console.log("applyCoupon");

        const form = event.target;
        const formData = new FormData(form);
        const router = Router(this.props.data.routes);

        let payload = Helpers.serializeFormData(formData);

        // console.log("payload", payload);

        let onResponse = {
            success: (response) => {
                //console.log("applyCoupon response", response);

                this.setState({
                    applying_coupon: false,
                    cart: response.data,
                    couponErrorMessage: response.errorMessage || ''
                }, () => {
                    this.onApplyCoupon(response);
                });
            },
            error: error => {
                console.log('error', error);
            },
            complete: () => {
                console.log('complete');
            }
        }

        if ($('#couponForm').valid()) {
            this.setState({
                applying_coupon: true,
                couponErrorMessage: ''
            }, () => {
                API.post(onResponse, payload, router.url('api.carts.applyCoupon', { cart: this.state.cart.id, site_id: this.props.data.active_site.id }));
            });
        }
    }


    calculateDiscount() {
        let discount = 0;

        _.forEach(this.state.cart.items, (item) => {

            discount += item.discounts;
        });

        return discount;
    }

    calculateTaxesAndFees() {
        let taxes_fees = 0;

        _.forEach(this.state.cart.items, (item) => {

            taxes_fees += item.taxes + item.fees + item.service;
        });

        return taxes_fees;
    }

    calculateFees() {
        let fees = 0;

        _.forEach(this.state.cart.items, (item) => {

            fees += item.fees + item.service;
        });

        return fees;
    }

    calculateTaxes() {
        let taxes = 0;

        _.forEach(this.state.cart.items, (item) => {

            taxes += item.taxes;
        });

        return taxes;
    }

    createTransaction() {
        console.log("createTransaction");

        this.setState({ show_loader: true });

        const router = Router(this.props.data.routes);

        const payload = {
            cart_id: this.state.cart.id,
            redirect_url: router.url('checkout', { domain: this.props.data.active_site.domain }),
            user_ip_address: this.state.user_ip_address,
            currency: this.state.currency,
            site_id: this.props.data.active_site.id,
        }

        const onResponse = {
            success: (response) => {
                window.location.reload(false);
                // this.setState({
                //     transaction: response
                // });
            },
            error: error => {
                console.log('failed to get new transaction form url:', error);
            },
            complete: () => {
                console.log('complete');
            }
        }

        API.post(onResponse, payload, router.url('createTransaction', { domain: this.props.data.active_site.domain }));
    }

    generateProductUrl(tour) {
        const router = Router(this.props.data.routes);

        let params = {
            domain: this.props.data.active_site.domain,
            id: tour.id,
            tour_slug: tour.slug
        };

        return router.url('tours.show', params);
    }

    measureRemoveFromCart(item_id) {
        //console.log("measureRemoveFromCart", item_id);

        const cart_item = _.find(this.state.cart.items, (_item) => { return _item.id == item_id; });

        let products = [];

        _.forEach(cart_item.participantList, (value, key) => {
            products.push({
                'name': cart_item.name,
                'price': value.price,
                'variant': value.tier.label,
                'quantity': 1
            });
        });

        //Google Analytics 4
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            'event': "remove_from_cart",
            'ecommerce': {
                'items': products
            }
        });
        //Universal Analytics (old)
        dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
                'remove': {
                    'products': products
                }
            }
        });
    }

    onApplyCoupon(data) {
        this.createTransaction();

        pubsub.publish('UPDATE_CART', [data]);
    }

    onBillingCCExpMonthChange(event) {
        this.setState({
            billingCCExpMonth: event.target.value.toString()
        });
    }

    onBillingCCExpYearChange(event) {
        this.setState({
            billingCCExpYear: event.target.value.toString()
        });
    }

    onCreditCardChange(event) {
        this.setState({
            creditCardNo: event.target.rawValue
        });
    }

    onCreditCardTypeChanged(type) {
        //console.log("onCreditCardTypeChanged", type)

        this.setState({
            creditCardType: type
        });
    }

    onCVVChange(event) {
        this.setState({
            cvv: event.target.rawValue
        });
    }

    onPhoneChange(event) {
        this.setState({
            phoneNumber: event.target.rawValue
        });
    }

    onRemoveFromCart(data) {
        this.createTransaction();

        pubsub.publish('UPDATE_CART', [data]);
    }

    onSubmit() {
        if ($('#checkoutForm').valid()) {
            this.setState({
                show_loader: true
            });
        }
    }

    // removeFromCart(itemId, token) {
    //     const formData = new FormData();
    //     formData.append("_token", token);
    //     formData.append("item_id", itemId);
    // }

    async asyncRemoveItemFromCart(itemId, token) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("_token", token);
            formData.append("item_id", itemId);

            const router = Router(this.props.data.routes);

            let payload = Helpers.serializeFormData(formData);
            // console.log("payload itemId", payload.item_id);

            this.measureRemoveFromCart(payload.item_id);

            let onResponse = {
                success: (response) => {
                    // console.log("removeFromCart response", response);
                    this.onRemoveFromCart(response);
                    console.log('async removed item from cart');
                    resolve();
                },
                error: error => {
                    console.log('error', error);
                    reject("Something went wrong");
                },
                complete: () => {
                    console.log('complete');
                }
            }
            API.post(onResponse, payload, router.url('removeItemFromCart', { domain: this.props.data.active_site.domain, cart: this.state.cart.id, site_id: this.props.data.active_site.id }));
        });
    }

    removeFromCart(itemId, tourId) {
        // event.preventDefault();

        //console.log("removeFromCart");

        // const form = event.target;
        // const formData = new FormData(form);
        const formData = new FormData();
        formData.append("_token", this.props.data.csrf_token);
        formData.append("item_id", itemId);

        const router = Router(this.props.data.routes);

        let payload = Helpers.serializeFormData(formData);
        console.log("payload itemId", payload.item_id);

        this.measureRemoveFromCart(payload.item_id);

        let onResponse = {
            success: (response) => {
                console.log("removeFromCart response", response);

                this.setState({
                    show_loader: false,
                    cart: response
                }, () => {
                    this.onRemoveFromCart(response);
                    this.removeLocalCartItem(tourId);
                });
            },
            error: error => {
                console.log('error', error);
            },
            complete: () => {
                console.log('complete');
            }
        }

        this.setState({
            show_loader: true
        }, () => {
            API.post(onResponse, payload, router.url('removeItemFromCart', { domain: this.props.data.active_site.domain, cart: this.state.cart.id }));
        });
    }

    //for editing
    loadCartItemInfo(tour, cartItem) {
        this.setState({
            is_loading: true,
            item_to_edit: cartItem,
            target_tour_of_edit: tour,
            pickup_options_edit: [],
            product_items_edit: {},
        })

        //get tour options
        fetch("/tour_options?resmark_id=" + tour.resmark_id)
            .then(res => res.json())
            .then(data => {
                // console.log("data", data);
                let pickupLocation;

                _.forEach(data.pickup_options, (pickup) => {
                    const itemPickupLocation = _.find(pickup.options, (pickupOption) => cartItem.pickup.location._id == pickupOption.id);
                    if (itemPickupLocation) {
                        // console.log("current location", itemPickupLocation);
                        pickupLocation = itemPickupLocation;
                        return;
                    }
                });

                const productItem = _.find(data.product_items.items, (item) => {
                    return Helpers.toDateString(item.date) === Helpers.toDateString(cartItem.date.startTime);
                });

                const timeAvailable = _.find(productItem.timesAvailable, (timeAvailable) => {
                    return Helpers.toDayDateTimeString(timeAvailable.startTime) === Helpers.toDayDateTimeString(cartItem.date.startTime);
                });

                let tiers = _.groupBy(cartItem.participantList, 'tier.key');
                if (_.isEmpty(tiers))
                    tiers = _.groupBy(cartItem.unitList, 'tier.key');

                const participants = {};
                for (const key in tiers) {
                    participants[key] = tiers[key].length
                }

                this.setState({
                    bookingDefaultValues: {
                        pickupLocation,
                        pickupTime: timeAvailable,
                        participants,
                        price: cartItem.price,
                    },
                    // item_to_edit: cartItem,
                    // target_tour_of_edit: tour,
                    product_items_edit: data.product_items,
                    pickup_options_edit: data.pickup_options,
                    is_loading: false,
                    is_editing_item: true,
                })
            })
            .catch(console.log);
    }

    loadTourInfo(tour) {
        this.setState({
            is_loading: true,
            item_to_edit: null,
            target_tour_of_edit: tour,
            pickup_options_edit: [],
            product_items_edit: null,
            bookingDefaultValues: null
        })

        //get tour options
        fetch("/tour_options?resmark_id=" + tour.resmark_id)
            .then(res => res.json())
            .then(data => {
                console.log("loaded options", data);
                this.setState({
                    product_items_edit: data.product_items,
                    pickup_options_edit: data.pickup_options,
                    is_loading: false,
                    is_editing_item: true,
                })
            })
            .catch(console.log);
    }

    measureAddToCart(product) {
        let products = [];

        _.forEach(participants, (value, key) => {
            products.push({
                name: product.name,
                id: product.resmark_id,
                price: selectedPickupTime.value.price[key],
                category: product.categories_string,
                variant: key,
                quantity: value,
            });
        });

        //Google Analytics 4
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                items: products
            }
        });

        //Universal Analytics (old)
        dataLayer.push({
            event: "addToCart",
            ecommerce: {
                currencyCode: "USD",
                add: {
                    products: products,
                },
            },
        });
    }

    async addItemsToCart(itemsToAdd) {

        const router = Router(this.props.data.routes);

        Promise.all(itemsToAdd.map(({ item, tour }) => {
            return new Promise((resolve, reject) => {
                const formData = new FormData();

                for (const key in item) {
                    formData.append(key, item[key]);
                }

                let payload = Helpers.serializeFormData(formData);
                payload.participants = item.participants;

                // console.log("form data", formData);
                // console.log("payload", payload);

                const onResponse = {
                    success: (response) => {
                        resolve(response);
                    },
                    error: (error) => {
                        // setAddingToCart(false);
                        console.log("error", error);
                        reject(error);
                        // setCartErrorMessage("Oops! Something went wrong.");
                    },
                    complete: () => {
                        console.log("complete");
                    },
                };

                // setAddingToCart(true);
                console.log("add item route", router.url("addItemToCart", { domain: this.props.data.active_site.domain, cart: this.state.cart.id }));

                API.post(
                    onResponse,
                    payload,
                    router.url("addItemToCart", { domain: this.props.data.active_site.domain, cart: this.state.cart.id })
                );
            })

        }))
            .then(() => window.location.reload())
            .catch((error) => {
                console.log("preserving error", error);
                window.location.reload();
            });
    }

    onAddToCart(data) {
        console.log(data, pubsub);
        pubsub.publish("UPDATE_CART", [data]);
        setItemAdded(true);
    }

    async preserveCartItems() {

        // const itemTours = this.state.cart.items.map(item => {
        //     let tour = _.find(this.props.data.tours.data, (_tour) => { return _tour.name == item.name && _tour.post_status.name == 'Published'; });
        //     return {item, tour};
        // });

        //store items in local storage
        // console.log("itemtours", itemTours);
        // localStorage.setItem("cartItemTours", JSON.stringify({
        //     expiration: new Date().getTime() + 12 * 60 * 60 * 1000, 
        //     data: itemTours
        // }));


        const itemsToBeAdded = await Promise.all(
            this.state.localCart.items.map(({ item: cartItem, tour }) => (
                new Promise(async (resolve, reject) => {
                    // console.log("cart item", cartItem);
                    // console.log("tour", tour);
                    let pickupDetailId;

                    try {
                        //get tour options and find the  previously selected one to add to cart
                        const response = await fetch("/tour_options?resmark_id=" + tour.resmark_id);
                        const data = await response.json();
                        _.forEach(data.pickup_options, (pickup) => {
                            const itemPickupLocation = _.find(pickup.options, (pickupOption) => cartItem.pickup.location._id == pickupOption.id);
                            if (itemPickupLocation) {
                                // console.log("current location", itemPickupLocation);
                                pickupDetailId = itemPickupLocation.pickup_details[0].id;
                                return;
                            }
                        });

                        const tiers = _.groupBy(cartItem.participantList, 'tier.key');

                        const participants = {};
                        for (const key in tiers) {
                            participants[key] = tiers[key].length
                        }

                        resolve({
                            tour,
                            item: {
                                _token: this.props.data.csrf_token,
                                cartId: this.state.cart.id,
                                itemId: cartItem.id,
                                locationId: cartItem.pickup.location._id,
                                participants,
                                pickupDetailId,
                            }
                        });

                    } catch (error) {
                        return reject(error.message);
                    }
                })
            ))
        );

        this.addItemsToCart(itemsToBeAdded);
    }

    removeFailedPreservedItem(itemId) {

        console.log("remove unpreserved id", itemId);
        const newFailedPreserveItems = this.state.failedPreserveItems.filter(({ tour }) => (
            itemId !== tour.id
        ));

        this.setState({
            failedPreserveItems: newFailedPreserveItems,
        });

        return newFailedPreserveItems;
    }

    removeLocalCartItem(tourId) {
        console.log("remove unpreserved id", tourId);
        const newLocalCartItems = this.state.localCart.items.filter(({ tour }) => (
            tourId !== tour.id
        ));
        // console.log("local cart items", newLocalCartItems);

        const newLocalCart = {
            ...this.state.localCart,
            items: newLocalCartItems
        }

        this.setState({
            localCart: newLocalCart
        });

        localStorage.setItem("cart", JSON.stringify(newLocalCart));
    }

    UnpreservedItemsList() {

        const { tours, env } = this.props.data;

        return (
            <div className="unpreserved-tours pl-4" style={{ borderLeft: "5px solid #ffa500" }}>
                <h5 className="body-font mb-5 font-weight-bold" style={{ color: "#ffa500" }}>
                    We couldn't preserve these tours for you;
                    the dates you chose may not be available anymore.
                    You'll need to update your booking.
                </h5>

                {this.state.failedPreserveItems.map(({ item, tour }, index) => {
                    // console.log("preserved tour", tour);
                    return (
                        <CartItem
                            key={index}
                            onRemove={() => {
                                this.removeFailedPreservedItem(tour.id);
                                this.removeLocalCartItem(tour.id);
                            }}
                            item={item}
                            tour={tour}
                            price={env.CURRENCY + ' ' + Helpers.formatCurrency(item.price)}
                            actions={[
                                {
                                    fire: (tour) => {
                                        this.loadTourInfo(tour);
                                        $("#bookingWidgetModal").modal();

                                        if (!tours.data.find(_tour => _tour.id == tour.id))
                                            tours.data.push(tour);
                                    },
                                    label: "Update booking",
                                    icon: "far fa-fw fa-edit"
                                },
                                {
                                    fire: () => {
                                        console.log("fire - remove item", tour.id);
                                        this.removeFailedPreservedItem(tour.id);
                                        this.removeLocalCartItem(tour.id)
                                    },
                                    label: "Remove",
                                    icon: "fa fa-trash",
                                    color: "text-danger",
                                }
                            ]}
                        />
                    );
                })}
            </div>
        );
    }

    isBahamasSite() {
        // return this.props.data.active_site.domain.split(".")[0] == "discoverbahamas";
        return this.props.data.active_site.domain.search(/bahamas/i) >= 0;
    }

    isExclusiveSite() {
        return this.props.data.active_site.domain.search(/exclusive/i) >= 0;
    }

    render() {
        const { active_site, csrf_token, notification, related_tours, request, routes, tours, env } = this.props.data;
        const router = Router(routes);
        const phone_number = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'phone_number'; });
        const terms_of_service_message = _.find(this.props.data.active_site.settings.data, (setting) => { return setting.key == 'terms_of_service_message'; });
        //const sidebar_recommendation = _.sample(related_tours.data);

        // console.log(this.state.isCartExpired);
        // console.log("cart items", this.state.cart.items);
        // console.log("failed preserve items", this.state.failedPreserveItems);
        // console.log("transaction", this.state.transaction);
        // console.log("cart", this.state.cart);

        return (
            <div>
                <div className="container-fluid pt-5 pb-10">

                    {/* booking widget modal for edits */}
                    <div className="modal fade" id="bookingWidgetModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content position-relative">
                                <div className="modal-header border-none position-absolute z-3" style={{ right: "10px" }}>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {this.state.is_loading &&
                                        <div className="my-5 px-4 text-center">
                                            <div className="preloader-wrapper active crazy">
                                                <div className="spinner-layer spinner-red-only spinner-primary">
                                                    <div className="circle-clipper left">
                                                        <div className="circle"></div>
                                                    </div>
                                                    <div className="gap-patch">
                                                        <div className="circle"></div>
                                                    </div>
                                                    <div className="circle-clipper right">
                                                        <div className="circle"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="body-font">
                                                Checking available dates...
                                            </p>
                                        </div>
                                    }
                                    {(this.state.is_editing_item && !this.state.is_loading) &&
                                        <BookingWidget
                                            {...this.props.data}
                                            editMode
                                            defaultValues={this.state.bookingDefaultValues}
                                            tour={this.state.target_tour_of_edit}
                                            product_items={this.state.product_items_edit}
                                            pickup_options={this.state.pickup_options_edit}
                                            beforeAddedToCart={async () => {
                                                if (this.state.item_to_edit)
                                                    await this.asyncRemoveItemFromCart(this.state.item_to_edit.id, csrf_token);
                                            }}
                                            pickupLocationLabel={
                                                this.isBahamasSite() ?
                                                    "Which resort are you staying at?" :
                                                    "Where can we pick you up?"
                                            }
                                            onAddedToCart={(cartData, removedTour) => {
                                                console.log("cart data", cartData);

                                                // reset cart expire timer
                                                // this.setState({
                                                //     cartExpirationCount: this.state.cartExpirationCount++
                                                // })

                                                //remove item from unpreserved list if present
                                                this.removeFailedPreservedItem(removedTour.id);

                                                $("#bookingWidgetModal").modal("hide");
                                                // this.setState({
                                                //     cart: cartData,
                                                //     editMessages: [
                                                //         ...this.state.editMessages, 
                                                //         this.state.item_to_edit ? 
                                                //             `${this.state.item_to_edit.name} tour updated successfully!`
                                                //             :
                                                //             "Tour updated successfully!"
                                                //     ]
                                                // });

                                                //create transaction after every cart edit
                                                // this.createTransaction();        
                                                pubsub.publish('UPDATE_CART', [cartData]);

                                                this.setState({
                                                    show_loader: true
                                                })
                                                window.location.reload(false);
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container p-0">
                        {
                            _.isEmpty(this.state.cart.items) ?
                                <div>
                                    <div className="row">
                                        <div className="col-12 col-md-10 mx-auto">
                                            <div className="text-center mb-5 pt-6">
                                                <div className="mb-3"><i className="fa fa-shopping-cart fa-3x primary-text"></i></div>
                                                <h1 className="body-font font-weight-bold">
                                                    Your Cart Is Empty
                                                </h1>
                                                <div className="four-b-text mb-4">
                                                    <span className="font-large">
                                                        {this.isBahamasSite() || this.isExclusiveSite() ? "Start by choosing your tour." : "Start by choosing your destination."}
                                                    </span>
                                                </div>

                                                {this.isBahamasSite() ?
                                                    <a href={`http://${active_site.domain}`} className="btn btn-lg btn-rounded white-text btn-primary py-3 px-4">
                                                        <i className="fa fa-list-ul mr-2"></i>Choose Your Tour
                                                    </a>
                                                    : this.isExclusiveSite() ?
                                                        <a href={`http://${active_site.domain}/#tours`} className="btn btn-lg btn-rounded white-text btn-primary py-3 px-4">
                                                            <i className="fa fa-list-ul mr-2"></i>Choose Your Tour
                                                        </a>
                                                        :
                                                        <button className="btn btn-lg btn-rounded white-text btn-primary py-3 px-4" data-target="#destination-modal" data-toggle="modal" tabIndex="0">
                                                            <i className="fa fa-list-ul mr-2"></i>Choose Your Destination
                                                        </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {!_.isEmpty(this.state.failedPreserveItems) &&
                                        <div className="row">
                                            <div className="col col-md-8 m-auto">
                                                {this.UnpreservedItemsList()}
                                            </div>
                                        </div>
                                    }
                                </div>

                                :

                                <div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="text-center mb-10 pt-6 d-none d-lg-block">
                                                <div className="mb-3"><i className="fa fa-shopping-cart fa-3x"></i></div>
                                                <h1 className="body-font font-weight-bold">
                                                    Complete Checkout
                                                </h1>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="d-none d-lg-block col-lg-4">
                                            <div className="card mb-3 z-depth-0">
                                                {
                                                    !_.isEmpty(this.state.sidebar_recommendation) &&
                                                    <div className="card-body border-rounded-6p">
                                                        <h5 className="font-weight-bold mb-3 body-font">You might also like</h5>
                                                        <div className="mb-2">
                                                            <img className="img-fluid" src={this.state.sidebar_recommendation.cover_photo.medium} />
                                                        </div>

                                                        {
                                                            !_.isNull(this.state.sidebar_recommendation.average_rating) &&
                                                            <ReviewRating
                                                                star_rating={this.state.sidebar_recommendation.average_rating}
                                                                count={this.state.sidebar_recommendation.reviews_count}
                                                                dark_mode={true}
                                                            />
                                                        }

                                                        <div className="mb-3">
                                                            <h4 className="font-weight-bold mb-0 body-font">
                                                                <span>{this.state.sidebar_recommendation.name}</span>
                                                            </h4>
                                                        </div>

                                                        <a href={this.generateProductUrl(this.state.sidebar_recommendation)} className="btn btn-block btn-rounded py-3 btn-primary text-white font-weight-bold">
                                                            Learn More
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                            {/* get tripadvisor image and copy from settings data */}
                                            {!this.isExclusiveSite() && <div className="card mb-3 z-depth-0">
                                                <div className="card-body border-rounded-6p">
                                                    <div className="text-center">
                                                        <div className="mb-3">
                                                            <img className="w-100 img-fluid" src="/images/Tripadvisor-award-2024-white-bg.png" />
                                                        </div>
                                                        {
                                                            !this.isBahamasSite() &&
                                                            !this.isExclusiveSite() &&
                                                            <React.Fragment>
                                                                <h4 className="font-weight-bold body-font mb-3">
                                                                    12 Times!
                                                                </h4>

                                                                <p>
                                                                    Island Routes has won the Trip Advisor Travelers Choice Award for the 12th time.
                                                                </p>
                                                            </React.Fragment>
                                                        }
                                                    </div>
                                                    {
                                                        !this.isExclusiveSite() &&
                                                        <React.Fragment>

                                                            <hr className="four-a" />

                                                            <ul className="list-unstyled mb-0">
                                                                <li className="mb-3">
                                                                    <div className="media">
                                                                        <div className="align-self-center mr-2">
                                                                            <i className="fa fa-check-circle fa-lg primary-text"></i>
                                                                        </div>
                                                                        <div className="media-body align-self-center">
                                                                            <h5 className="font-weight-bold mb-0 body-font">Flexible Cancellation</h5>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li className="mb-3">
                                                                    <div className="media">
                                                                        <div className="align-self-center mr-2">
                                                                            <i className="fa fa-check-circle fa-lg primary-text"></i>
                                                                        </div>
                                                                        <div className="media-body align-self-center">
                                                                            <h5 className="font-weight-bold mb-0 body-font">Quality Assured</h5>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li className="mb-3">
                                                                    <div className="media">
                                                                        <div className="align-self-center mr-2">
                                                                            <i className="fa fa-check-circle fa-lg primary-text"></i>
                                                                        </div>
                                                                        <div className="media-body align-self-center">
                                                                            <h5 className="font-weight-bold mb-0 body-font">Secure Checkout</h5>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="media">
                                                                        <div className="align-self-center mr-2">
                                                                            <i className="fa fa-check-circle fa-lg primary-text"></i>
                                                                        </div>
                                                                        <div className="media-body align-self-center">
                                                                            <h5 className="font-weight-bold mb-0 body-font">Experienced Support</h5>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </React.Fragment>
                                                    }
                                                </div>
                                            </div>}


                                            <div className="card mb-3 z-depth-0 border p-3">
                                                <div className="accordion" id="accordionContactWidget" role="tablist" aria-multiselectable="true">
                                                    <div className="card z-depth-0 p-0 border-0">
                                                        <h4 className="mt-2 mb-0 font-weight-bold d-flex justify-content-between align-content-center">
                                                            <span className="body-font"><i className="fa fa-fw fa-mobile-alt"></i> Contact Us</span>
                                                        </h4>
                                                        <div className="card-body p-1 my-4">
                                                            <div>
                                                                <div className="media-body">
                                                                    <p className="mb-1 body-font primary-text">Book by phone</p>

                                                                    {
                                                                        !_.isEmpty(phone_number) &&
                                                                        <h5 className="mb-0 font-weight-bold body-font"><span className="font-largest">{phone_number.value}</span></h5>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-8">
                                            {
                                                !_.isEmpty(notification) &&
                                                <Notification notification={notification} />
                                            }

                                            {this.state.editMessages.map((message, index) => (
                                                <div key={index} class="alert alert-success alert-dismissible fade show" role="alert">
                                                    {message}
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                            ))}

                                            <div className="row">
                                                <div className="col">
                                                    <CartExpireCountdown
                                                        onPreserveCart={this.preserveCartItems}
                                                        count={this.state.cartExpirationCount}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="mb-2 z-depth-0">
                                                        <div className="border-rounded-6p">
                                                            <div className="d-flex justify-content-between align-items-end">
                                                                <h4 className="font-weight-bold mb-4 body-font"><i className="far fa-fw fa-file-alt mr-2"></i>Summary</h4>
                                                                <p className="text-muted mb-0"><span className="font-italic font-small">{this.state.cart.items.length} items</span></p>
                                                            </div>

                                                            {
                                                                this.state.cart.items.map((item, parent_key) => {

                                                                    let tour = _.find(tours.data, (_tour) => { return _tour.name == item.name && _tour.post_status.name == "Published"; });
                                                                    // console.log("tours", tours);
                                                                    //tour isn't going to be retrieved
                                                                    // console.log("car item tour", tour);

                                                                    return (
                                                                        <CartItem
                                                                            item={item}
                                                                            tour={tour}
                                                                            onRemove={(itemId, tourId) => this.removeFromCart(itemId, tourId)}
                                                                            key={parent_key}
                                                                            price={env.CURRENCY + ' ' + Helpers.formatCurrency(item.price)}
                                                                            actions={[
                                                                                {
                                                                                    label: "Edit",
                                                                                    icon: "far fa-fw fa-edit",
                                                                                    fire: (tour, item) => {
                                                                                        this.loadCartItemInfo(tour, item);
                                                                                        $("#bookingWidgetModal").modal();
                                                                                    }
                                                                                }
                                                                            ]}
                                                                        />
                                                                    );
                                                                })
                                                            }

                                                            {this.state.failedPreserveItems.length > 0 && this.UnpreservedItemsList()}

                                                            {this.isBahamasSite() ?
                                                                <div>
                                                                    <div className="border-top pt-2 d-flex justify-content-between align-items-center font-small text-dark">
                                                                        <div>
                                                                            <span className="text-muted">Taxes</span>
                                                                        </div>
                                                                        <div>
                                                                            <span className="font-weight-bold">{env.CURRENCY + ' ' + Helpers.formatCurrency(this.calculateTaxes())}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="border-bottom pb-2 d-flex justify-content-between align-items-center font-small text-dark">
                                                                        <div>
                                                                            <span className="text-muted">Fees</span>
                                                                        </div>
                                                                        <div>
                                                                            <span className="font-weight-bold">{env.CURRENCY + ' ' + Helpers.formatCurrency(this.calculateFees())}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="border-top pt-2 d-flex justify-content-between align-items-center font-small text-dark">
                                                                    <div>
                                                                        <span className="text-muted">Taxes & Fees</span>
                                                                    </div>
                                                                    <div>
                                                                        <span className="font-weight-bold">{env.CURRENCY + ' ' + Helpers.formatCurrency(this.calculateTaxesAndFees())}</span>
                                                                    </div>
                                                                </div>
                                                            }

                                                            {
                                                                this.calculateDiscount() < 0 &&
                                                                <div>
                                                                    <hr className="hr-1px hr-lightgray" />

                                                                    <div className="d-flex justify-content-between align-items-center font-small">
                                                                        <div>
                                                                            <span className="four-b-text">Discount</span>
                                                                        </div>
                                                                        <div>
                                                                            <span className="primary-text">{env.CURRENCY + ' ' + Helpers.formatCurrency(this.calculateDiscount())}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="font-large text-right">
                                                        <span>Grand Total:</span> <span className="primary-text font-weight-bold">{env.CURRENCY + ' ' + Helpers.formatCurrency(this.state.cart.total)}</span>
                                                    </div>

                                                    <hr className="four-a mt-6 mb-4" />

                                                    <div>
                                                        <button type="button" className="btn btn-link primary-text p-0" data-toggle="collapse" data-target="#couponCollapse">{this.isExclusiveSite() ? "Have a booking code?" : "Have a coupon?"}</button>
                                                    </div>

                                                    {
                                                        !_.isEmpty(this.state.couponErrorMessage) &&
                                                        <div className="row mt-2">
                                                            <div className="col-12">
                                                                <div className="alert alert-danger alert-dismissible fade show m-0">
                                                                    <div>{this.state.couponErrorMessage}</div>
                                                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className="collapse mt-2" id="couponCollapse">
                                                        <form id="couponForm" onSubmit={this.applyCoupon} className="mdb-form__dark">
                                                            <InputHidden name="_token" defaultValue={csrf_token} />

                                                            <div className="form-group form-row mb-0">
                                                                <div className="col-12 col-lg-8 mb-3 mb-lg-0">
                                                                    <input
                                                                        name="promoCode"
                                                                        type="text"
                                                                        id="promoCode"
                                                                        className="form-control form-control-xl"
                                                                        required
                                                                    />
                                                                    <label htmlFor="promoCode" className="input-label">{this.isExclusiveSite() ? 'Booking Code' : 'Coupon Code'}</label>
                                                                </div>
                                                                <div className="col-12 col-lg-4">
                                                                    <button type="submit" className="btn btn-primary btn-block py-3 px-4 h-100 m-0 border-0">
                                                                        <ul className="list-inline mb-0 d-flex align-items-center justify-content-center">
                                                                            {
                                                                                this.state.applying_coupon &&
                                                                                <li className="list-inline-item mr-3">
                                                                                    <div className="spinner-border spinner-border-md d-block" role="status"></div>
                                                                                </li>
                                                                            }

                                                                            <li className="list-inline-item font-weight-bold">
                                                                                {this.isExclusiveSite() ? 'Apply Code' : 'Apply Coupon'}
                                                                            </li>
                                                                        </ul>
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            <div className="form-group row">
                                                                <div className="col-12">
                                                                    <div className="d-none position-absolute" style={{ top: '0.65rem', right: '1.5rem' }}>
                                                                        <div className="preloader-wrapper active crazy">
                                                                            <div className="spinner-layer spinner-red-only border-color-one-d">
                                                                                <div className="circle-clipper left">
                                                                                    <div className="circle"></div>
                                                                                </div>
                                                                                <div className="gap-patch">
                                                                                    <div className="circle"></div>
                                                                                </div>
                                                                                <div className="circle-clipper right">
                                                                                    <div className="circle"></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    <hr className="four-a mb-6 mt-4" />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12">
                                                    <form id="checkoutForm" className="mdb-form__dark" action={this.state.transaction['form-url']}>
                                                        <div className="mb-3 mb-lg-6">
                                                            <h4 className="font-weight-bold body-font mb-4">
                                                                <i className="far fa-fw fa-user mr-2"></i>Billing Information
                                                            </h4>
                                                            {/* <hr className="four-a" /> */}

                                                            <div className="form-group form-row">
                                                                <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                                                                    <div>
                                                                        <input
                                                                            name="billing-first-name"
                                                                            type="text"
                                                                            id="billing-first-name"
                                                                            className="form-control form-control-xl"
                                                                            required
                                                                            minLength="2"
                                                                        />
                                                                        <label htmlFor="billing-first-name" className="input-label">First Name</label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-lg-6">
                                                                    <div>
                                                                        <input
                                                                            name="billing-last-name"
                                                                            type="text"
                                                                            id="billing-last-name"
                                                                            className="form-control form-control-xl"
                                                                            required
                                                                            minLength="2"
                                                                        />
                                                                        <label htmlFor="billing-last-name" className="input-label">Last Name</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group form-row">
                                                                <div className="col-12">
                                                                    <div>
                                                                        <input
                                                                            name="billing-email"
                                                                            data-validation="required email"
                                                                            type="email"
                                                                            id="billing-email"
                                                                            className="form-control form-control-xl"
                                                                            required
                                                                            email="true"
                                                                        />
                                                                        <label htmlFor="billing-email" className="input-label">Email</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group form-row">
                                                                <div className="col-7 col-md-8 mb-3">
                                                                    <div>
                                                                        <Cleave
                                                                            name="billing-phone"
                                                                            id="billing-phone"
                                                                            className="form-control form-control-xl"
                                                                            required
                                                                            minLength="10"
                                                                            maxLength="15"
                                                                            options={{ numericOnly: true }}
                                                                            onChange={this.onPhoneChange}
                                                                        />

                                                                        <label htmlFor="billing-phone" className="input-label">Phone Number</label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-5 col-md-4">
                                                                    <div>
                                                                        <input
                                                                            name="billing-postal"
                                                                            data-validation="required alphanumeric length"
                                                                            type="text"
                                                                            id="billing-postal"
                                                                            className="form-control form-control-xl"
                                                                            required
                                                                            minLength="3"
                                                                            maxLength="10"
                                                                        />
                                                                        <label htmlFor="billing-postal" className="input-label">Zip/Postal Code</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group form-row">

                                                            </div>
                                                        </div>

                                                        <h4 className="font-weight-bold body-font">
                                                            <i className="fa fa-fw fa-money-check-alt mr-2 mb-4"></i>
                                                            Payment Type
                                                        </h4>
                                                        <div className="mb-3 z-depth-0">
                                                            <div className="border-0 p-0 bg-white">
                                                                <ul className="nav nav-tabs nav-justified m-0 z-depth-0 p-0" role="tablist">
                                                                    <li className="nav-item">
                                                                        <a className="nav-link active p-3 rounded-0" data-toggle="tab" href="#panel5" role="tab"><i className="fa fa-credit-card mr-1"></i>Credit / Debit</a>
                                                                    </li>
                                                                    <li className="nav-item invisible">
                                                                        <a className="nav-link p-3 rounded-0" data-toggle="tab" href="#panel6" role="tab"><i className="fa fa-paypal mr-1"></i>PayPal</a>
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                            <div className="card-body border border-top-0 pt-1">
                                                                <div className="tab-content pl-0 pr-0 pb-0">
                                                                    <div className="tab-pane fade in show active" id="panel5" role="tabpanel">
                                                                        <div className="form-group form-row">
                                                                            <div className="col-12">
                                                                                <Cleave
                                                                                    name="billing-cc-number"
                                                                                    id="billing-cc-number"
                                                                                    className="form-control form-control-xl"
                                                                                    required
                                                                                    minLength="16"
                                                                                    options={{
                                                                                        creditCard: true,
                                                                                        onCreditCardTypeChanged: (type) => this.onCreditCardTypeChanged(type)
                                                                                    }}
                                                                                    onChange={event => this.onCreditCardChange(event)}
                                                                                />

                                                                                <label htmlFor="billing-cc-number" className="input-label">Card Number</label>

                                                                                {
                                                                                    !_.isEmpty(this.state.creditCardType) &&
                                                                                    <div className="position-absolute white-text" style={{ top: '50%', bottom: '0', transform: 'translateY(-50%)', right: '4rem' }}>
                                                                                        <i className={"fab fa-2x fa-cc-" + this.state.creditCardType}></i>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                        <input type="hidden" name="billing-cc-exp" value={this.state.billingCCExpMonth.concat(this.state.billingCCExpYear)} readOnly={true} />

                                                                        <div className="form-group form-row">
                                                                            <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                                                                                <select
                                                                                    id="month"
                                                                                    className="custom-select custom-select-xl pb-0"
                                                                                    required
                                                                                    onChange={(event) => this.onBillingCCExpMonthChange(event)}
                                                                                >
                                                                                    <option value="">Choose a month</option>

                                                                                    {
                                                                                        Array.apply(0, Array(12)).map((_, key) => {
                                                                                            let month = moment().month(key);

                                                                                            return (
                                                                                                <option key={key} value={month.format('MM')}>{month.format('MMMM')}</option>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </select>
                                                                                <label className="select-label">Expiry Month</label>
                                                                            </div>
                                                                            <div className="col-12 col-lg-6">
                                                                                <select
                                                                                    id="year"
                                                                                    className="custom-select custom-select-xl pb-0"
                                                                                    required
                                                                                    onChange={(event) => this.onBillingCCExpYearChange(event)}
                                                                                >
                                                                                    <option value="">Choose a year</option>

                                                                                    {
                                                                                        _.times(20, (key) => {

                                                                                            let date = moment().add(key, 'y');

                                                                                            return (
                                                                                                <option key={key} value={date.format('YY')}>{date.format('YYYY')}</option>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </select>
                                                                                <label className="select-label">Expiry Year</label>
                                                                            </div>
                                                                        </div>

                                                                        <div className="form-group form-row">
                                                                            <div className="col-6">
                                                                                <div>
                                                                                    <Cleave
                                                                                        name="billing-cvv"
                                                                                        id="billing-cvv"
                                                                                        className="form-control form-control-xl"
                                                                                        required
                                                                                        minLength="3"
                                                                                        maxLength="4"
                                                                                        options={{
                                                                                            blocks: [4],
                                                                                            numericOnly: true
                                                                                        }}
                                                                                        onChange={event => this.onCVVChange(event)}
                                                                                    />

                                                                                    <label htmlFor="billing-cvv" className="input-label">CVV</label>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-6">
                                                                                <img className="img-fluid d-flex align-self-start rounded" src="/images/IR_cvv.jpg" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div>
                                                            {
                                                                !_.isEmpty(terms_of_service_message) &&
                                                                <div className="mb-1 mt-5">
                                                                    <div dangerouslySetInnerHTML={{ __html: terms_of_service_message.value }}></div>
                                                                </div>
                                                            }

                                                            {/* controlled by terms and conditions set in admin */}
                                                            <div id="termsConditionsModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
                                                                <div className="modal-dialog modal-xl">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h2 className="modal-title mb-0 body-text-color body-font">Terms & Conditions</h2>
                                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                                <span aria-hidden="true"><i className="fa fa-lg fa-times"></i></span>
                                                                            </button>
                                                                        </div>
                                                                        <div className="modal-body max-viewport-80 overflow-y-auto">
                                                                            <div className="row">
                                                                                <div className="col-12 max-viewport-65 overflow-y-auto">
                                                                                    {
                                                                                        !_.isEmpty(this.state.terms_conditions) ?
                                                                                            <div dangerouslySetInnerHTML={{ __html: this.state.terms_conditions.value }} /> :
                                                                                            <p><i>No terms and conditions</i></p>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* controlled by terms and conditions set in admin */}
                                                            <div id="cancellationModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
                                                                <div className="modal-dialog modal-xl">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h2 className="modal-title mb-0 body-text-color body-font">Cancellation Policy</h2>
                                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                                <span aria-hidden="true"><i className="fa fa-lg fa-times"></i></span>
                                                                            </button>
                                                                        </div>
                                                                        <div className="modal-body max-viewport-80 overflow-y-auto">
                                                                            <div className="row">
                                                                                <div className="col-12 max-viewport-65 overflow-y-auto">
                                                                                    {
                                                                                        !_.isEmpty(this.state.cancellation_policy) ?
                                                                                            <div dangerouslySetInnerHTML={{ __html: this.state.cancellation_policy.value }} /> :
                                                                                            <p><i>No cancellation policy</i></p>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row form-group justify-content-end">
                                                                <div className="col-auto">
                                                                    <div className="text-center">
                                                                        <button
                                                                            type="submit"
                                                                            className="btn btn-rounded btn-block btn-primary font-weight-bold py-3 px-5"
                                                                            onClick={() => { this.onSubmit() }}
                                                                        >
                                                                            <ul className="list-inline mb-0 d-flex justify-content-center align-items-center">
                                                                                {
                                                                                    this.state.on_submit &&
                                                                                    <li className="list-inline-item mr-3">
                                                                                        <div className="spinner-border text-white" role="status"></div>
                                                                                    </li>
                                                                                }

                                                                                <li className="list-inline-item">
                                                                                    {env.CURRENCY + ' ' + Helpers.formatCurrency(this.state.cart.total)} - Confirm Booking
                                                                                </li>
                                                                            </ul>
                                                                        </button>
                                                                        <p className="mb-0 mt-2 font-small"><i className="fa fa-lock text-muted"></i> <span className="text-muted">100% safe and secure shopping</span></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </div>

                {
                    this.state.show_loader &&
                    <div className="view viewport-height position-fixed three-b opacity-75 w-100 z-max" style={{ left: 0, top: 0, bottom: 0, right: 0 }}>
                        <div className="progress md-progress primary-color z-3 mb-0">
                            <div className="indeterminate"></div>
                        </div>

                        <div className="mask d-flex justify-content-center align-items-center">
                            <div className="preloader-wrapper active crazy">
                                <div className="spinner-layer spinner-red-only spinner-primary">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

if (document.getElementById('cartIndex')) {

    const element = document.getElementById('cartIndex');
    const data = Object.assign({}, element.dataset);

    //console.log(data.data);

    ReactDOM.render(<App data={JSON.parse(data.data)} />, document.getElementById('cartIndex'));
}



// WEBPACK FOOTER //
// ./resources/js/components/CartIndex/App.js